// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yO8D","comment":"styles_comment__3vE6U"};